import r, { OPTIONS as z } from "../../managers/braze-instance.js";
import ControlMessage from "../models/control-message.js";
import HtmlMessage from "../models/html-message.js";
import InAppMessage from "../models/in-app-message.js";
import SlideUpMessage from "../models/slide-up-message.js";
import me from "../display/get-animation-effect.js";
import le from "../display/in-app-message-to-html.js";
import { logInAppMessageImpression } from "../log-in-app-message-impression.js";
import { ORIENTATION as pe, WindowUtils as no } from "../../util/window-utils.js";
import { isURIJavascriptOrData as tt } from "../../util/url-utils.js";
import { KeyCodes as ie } from "../../util/key-codes.js";
import { setupInAppMessageUI as ss } from "../../ui/js/index.js";
import { logger as E } from "../../../shared-lib/index.js";
import { toRgba as ae } from "../../util/color-utils.js";
import { isIFrame as At } from "../utils/in-app-message-utils.js";
import fe from "../../l10n/l10n-manager-factory.js";
export function showInAppMessage(e, t, s) {
  if (!r.rr()) return;
  if (ss(), null == e) return !1;
  if (e instanceof ControlMessage) return E.info("User received control for a multivariate test, logging to Braze servers."), logInAppMessageImpression(e), !0;
  if (!(e instanceof InAppMessage)) return !1;
  if (e.constructor === InAppMessage) return !1;
  e._h();
  var o = e instanceof HtmlMessage;
  if (o && !e.trusted && !r.tr()) return E.error('HTML in-app messages are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these messages.'), !1;
  if (null == t && (t = document.body), e.Ve()) {
    if (t.querySelectorAll(".ab-modal-interactions").length > 0) return E.info("Cannot show in-app message ".concat(e.message, " because another message is being shown.")), !1;
  }
  if (no.Uo()) {
    var _t = no.$o();
    if (_t === pe.PORTRAIT && e.orientation === InAppMessage.Orientation.LANDSCAPE || _t === pe.LANDSCAPE && e.orientation === InAppMessage.Orientation.PORTRAIT) {
      var _s = _t === pe.PORTRAIT ? "portrait" : "landscape",
        _o = e.orientation === InAppMessage.Orientation.PORTRAIT ? "portrait" : "landscape";
      return E.info("Not showing ".concat(_o, " in-app message ").concat(e.message, " because the screen is currently ").concat(_s)), !1;
    }
  }
  if (!r.tr()) {
    var _t2 = !1;
    if (e.buttons && e.buttons.length > 0) {
      var _s2 = e.buttons;
      for (var _e = 0; _e < _s2.length; _e++) if (_s2[_e].clickAction === InAppMessage.ClickAction.URI) {
        var _o2 = _s2[_e].uri;
        _t2 = tt(_o2);
      }
    } else e.clickAction === InAppMessage.ClickAction.URI && (_t2 = tt(e.uri));
    if (_t2) return E.error('Javascript click actions are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these actions.'), !1;
  }
  var i = document.createElement("div");
  if (i.className = "ab-iam-root v3", i.className += me(e), e.language && !o && (i.lang = e.language), e.Le() && (i.id = e.htmlId), r.ee(z.Jo) && (i.style.zIndex = (r.ee(z.Jo) + 1).toString()), t.appendChild(i), e.Oe()) {
    var _t3 = document.createElement("style");
    _t3.innerHTML = e.css, _t3.id = e.Ge(), null != r.ee(z.er) && _t3.setAttribute("nonce", r.ee(z.er)), document.getElementsByTagName("head")[0].appendChild(_t3);
  }
  var n = e instanceof SlideUpMessage,
    a = le(e, function (t) {
      if (e.Ve() && e.Bo()) {
        var _s3 = document.createElement("div");
        if (_s3.className = "ab-page-blocker", e.Oe() || (_s3.style.backgroundColor = ae(e.frameColor)), r.ee(z.Jo) && (_s3.style.zIndex = r.ee(z.Jo).toString()), i.appendChild(_s3), !r.ee(z.Lh)) {
          var _o3 = new Date().valueOf();
          _s3.onclick = function (s) {
            new Date().valueOf() - _o3 > InAppMessage.Ph && (e.ll(t), s.stopPropagation());
          };
        }
        i.appendChild(t), t.focus(), e.Ah(i);
      } else if (n) {
        var _s4 = document.querySelectorAll(".ab-slideup");
        var _o4 = null;
        for (var _e2 = _s4.length - 1; _e2 >= 0; _e2--) if (_s4[_e2] !== t) {
          _o4 = _s4[_e2];
          break;
        }
        if (e.slideFrom === InAppMessage.SlideFrom.TOP) {
          var _e3 = 0;
          null != _o4 && (_e3 = _o4.offsetTop + _o4.offsetHeight), t.style.top = Math.max(_e3, 0) + "px";
        } else {
          var _e4 = 0;
          null != _o4 && (_e4 = (window.innerHeight || document.documentElement.clientHeight) - _o4.offsetTop), t.style.bottom = Math.max(_e4, 0) + "px";
        }
      } else if (o && !r.ee(z.Lh)) {
        var _s5 = e;
        At(t) && t.contentWindow && t.contentWindow.addEventListener("keydown", function (e) {
          e.keyCode === ie.Oh && _s5.closeMessage();
        });
      }
      logInAppMessageImpression(e), e.dismissType === InAppMessage.DismissType.AUTO_DISMISS && setTimeout(function () {
        i.contains(t) && e.ll(t);
      }, e.duration), "function" == typeof s && s();
    }, function (e) {
      E.info(e);
    }, r.ee(z.Do), r.ee(z.Jo), r.ee(z.er), t, fe.ea().So());
  return (o || n) && (i.appendChild(a), e.Ah(i)), !0;
}